import destinationPath from '~/utils/destinationPath';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SplashSlideModuleType =
  | 'homepage-header-carousel'
  | 'plp-image-1-banner'
  | 'plp-image-2-banner'
  | 'plp-image-3-banner'
  | 'plp-mid-banner'
  | 'plp-top-banner';

export type SplashSlideTargetProperties = {
  clickref?: string;
  destination_path?: string;
  destination_url?: string;
  heading?: string;
  image_url: string;
  module_position?: number;
  module_type: SplashSlideModuleType;
  position: number;
  retailer_id?: string;
};

type EventData = {
  clickref?: string;
  destinationPath?: string;
  destinationUrl?: string;
  gesture?: string;
  guestId?: string;
  heading?: string;
  imageUrl: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType: SplashSlideModuleType;
  position: number;
  retailerId?: string;
};

class SplashSlideInteractionEvent extends InteractionEvent<
  EventData,
  SplashSlideTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'splash_slide';
  }

  // An external slide is a direct click-out and an internal one navigates away, so the beacon
  // must survive the document unloading.
  protected get keepalive(): boolean {
    return true;
  }

  // No slide id exists anywhere in the chain (Quad, DA, CAPI), so `image_url` is the slide's
  // identity and `heading` its readable label. Exactly one of `destination_path` /
  // `destination_url` is set, and which one is the internal / external split; the path goes
  // through the shared helper, which strips only an origin that serves our pages. A clickref is
  // only minted where the CTA carries tracking templates; an unminted one is omitted, never ''.
  protected getTargetProperties(): SplashSlideTargetProperties {
    return {
      clickref: this.data.clickref || undefined,
      destination_path:
        this.data.destinationPath === undefined
          ? undefined
          : destinationPath(this.data.destinationPath),
      destination_url: this.data.destinationUrl,
      heading: this.data.heading,
      image_url: this.data.imageUrl,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      position: this.data.position,
      retailer_id: this.data.retailerId
    };
  }
}

export default SplashSlideInteractionEvent;
